import { render } from "./ChildInfoDialog.vue?vue&type=template&id=b35bef62&scoped=true"
import script from "./ChildInfoDialog.vue?vue&type=script&lang=js"
export * from "./ChildInfoDialog.vue?vue&type=script&lang=js"

import "./ChildInfoDialog.vue?vue&type=style&index=0&id=b35bef62&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35bef62"]])

export default __exports__